<script lang="ts">
    import { baseURL } from "../config"
    import Row from "./Row.svelte"

    export let rows: Row[]
    export let contentId: string
    /* export let sprungpunkte: { idx: number; titel: string }[] = null */
    /* export let scrollToElement: Function = (_options) => {} */

    rows.forEach((row) => {
        row.cols.forEach((col) => {
            if (col.type == "text") {
                const regex = /<a href="([^"]*)"(.*?)>([^<]*)<\/a>/g
                let match
                while ((match = regex.exec(col.text))) {
                    const link = match[1]
                    const atts = match[2]
                    const text = match[3]
                    if (link.startsWith("http") && !link.startsWith(baseURL)) {
                        col.text = col.text.replace(
                            `<a href="${link}"${atts}>${text}</a>`,
                            `<a href="${link}"${atts} class="external">${text}</a>`
                        )
                    } else {
                        col.text = col.text.replace(
                            `<a href="${link}"${atts}>${text}</a>`,
                            `<a href="${link}">${text}</a>`
                        )
                    }
                }
            }
        })
    })
</script>

{#each rows as row, idx}
    <Row row="{row}" contentId="{contentId}" />
{/each}
